export function OrganizationJsonLd() {
  const data = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Dev Cubix",
    url: "https://devcubix.com",
    logo: "https://devcubix.com/icon.svg",
    description:
      "Full-stack digital agency offering UI/UX design, web development, graphic design, presentation design, and AI solutions.",
    foundingDate: "2022",
    numberOfEmployees: {
      "@type": "QuantitativeValue",
      minValue: 40,
    },
    address: {
      "@type": "PostalAddress",
      streetAddress: "#A5 Federal Arcade, Chackshehzad",
      addressLocality: "Islamabad",
      addressCountry: "PK",
    },
    contactPoint: [
      {
        "@type": "ContactPoint",
        telephone: "+92-319-0708852",
        contactType: "sales",
        availableLanguage: ["English", "Urdu"],
      },
    ],
    sameAs: [
      "https://facebook.com/thedevcubix",
      "https://twitter.com/devcubix",
      "https://linkedin.com/company/dev-cubix",
      "https://instagram.com/devcubix",
    ],
    founder: [
      { "@type": "Person", name: "Nabeel Imdad", jobTitle: "Creative Director" },
      { "@type": "Person", name: "Bilal Ahmad", jobTitle: "Tech Lead" },
      { "@type": "Person", name: "Zeerak Ali", jobTitle: "Business Partner" },
      { "@type": "Person", name: "Hamza Imdad", jobTitle: "Design Analyst" },
    ],
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}

export function LocalBusinessJsonLd() {
  const data = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "@id": "https://devcubix.com/#localbusiness",
    name: "Dev Cubix",
    image: "https://devcubix.com/icon.svg",
    url: "https://devcubix.com",
    telephone: "+92-319-0708852",
    email: "info@devcubix.com",
    address: {
      "@type": "PostalAddress",
      streetAddress: "#A5 Federal Arcade, Chackshehzad",
      addressLocality: "Islamabad",
      addressRegion: "Islamabad Capital Territory",
      postalCode: "44000",
      addressCountry: "PK",
    },
    priceRange: "$$",
    openingHoursSpecification: {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      opens: "09:00",
      closes: "18:00",
    },
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: "4.9",
      reviewCount: "50",
      bestRating: "5",
    },
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}

export function WebSiteJsonLd() {
  const data = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "Dev Cubix",
    url: "https://devcubix.com",
    potentialAction: {
      "@type": "SearchAction",
      target: "https://devcubix.com/projects?q={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}

export function ServiceJsonLd({
  name,
  description,
  url,
  price,
}: {
  name: string;
  description: string;
  url: string;
  price?: string;
}) {
  const data = {
    "@context": "https://schema.org",
    "@type": "Service",
    name,
    description,
    url,
    provider: {
      "@type": "Organization",
      name: "Dev Cubix",
      url: "https://devcubix.com",
    },
    areaServed: {
      "@type": "Place",
      name: "Worldwide",
    },
    ...(price && {
      offers: {
        "@type": "Offer",
        price,
        priceCurrency: "USD",
      },
    }),
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}

export function FAQJsonLd({
  questions,
}: {
  questions: { question: string; answer: string }[];
}) {
  const data = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: questions.map((q) => ({
      "@type": "Question",
      name: q.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: q.answer,
      },
    })),
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}

export function BreadcrumbJsonLd({
  items,
}: {
  items: { name: string; url: string }[];
}) {
  const data = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: item.name,
      item: item.url,
    })),
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}
